"use strict";

var isFunction = require('lodash.isfunction');
var isString = require('lodash.isstring');
var intelligentFormat = require('./intelligentFormat');
var constants = require('./constants').currencies;
var currencyFormat;

currencyFormat = module.exports = {

    format: function (currency, model, financialAmount, options) {
        var isNegative = false;
        var amount;
        var result;
        var fn;
        if (financialAmount && isFunction(financialAmount.getAmountIn)) {
            amount = financialAmount.getAmountIn(currency);
        } else if (isString(financialAmount)) {
            fn = financialAmount;
            amount = model[fn](currency);
        }

        if (amount < 0) {
            isNegative = true;
            amount = amount * -1;
        }

        result = intelligentFormat(amount, currency, Object.assign(options || {}, {
            thousandsSeparator: ',',
            decimalMark: '.'
        }));

        return isNegative ? '- ' + result : result;
    },

    domtFormat: function (transaction, financialAmount) {
        var currency = transaction.getItemCurrency();
        return currencyFormat.format(currency, transaction, financialAmount, {});
    },

    iomtFormat: function (transaction, financialAmount) {
        var usdCurrency = '';
        var secCurrency = '';
        var itemCurrency = transaction.getItemCurrency();

        usdCurrency = currencyFormat.format(constants.CURRENCY_USD, transaction, financialAmount, {});

        if (itemCurrency !== constants.CURRENCY_USD) {
            secCurrency = ' (' + currencyFormat.domtFormat(transaction, financialAmount) + ')';
        }

        return usdCurrency + secCurrency;
    }

};



//////////////////
// WEBPACK FOOTER
// ./~/dibs-currency-helpers/currencyFormat.js
// module id = 756
// module chunks = 4 5 7 12 14 23